import { gql } from '@apollo/client';

export const UPDATE_TRUSTS_USER_MUTATION = gql`
  mutation UpdateTrustsUser($trustsUserUpdateDto: TrustsUserUpdateDto!) {
    updateTrustsUser(trustsUserUpdateDto: $trustsUserUpdateDto) {
      email
      status
      enabled
      createdDate
    }
  }
`;
